import { Helpers } from '../../helpers';
import { IProjectSuperStatus } from '../../interfaces/iproject-super-status';
import { ProjectStatus } from '../project-status';

export class ProjectSuperStatusBase {
  ProjectSuperStatusId: number;
  Description: string;
  SortOrder: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  ProjectStatuses_ProjectSuperStatus?: Array<ProjectStatus> | null;

  constructor(item?: IProjectSuperStatus) {
    if (item) {

      this.ProjectSuperStatusId = item.ProjectSuperStatusId;
      this.Description = item.Description;
      this.SortOrder = item.SortOrder;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.ProjectStatuses_ProjectSuperStatus = Helpers.createClassArray(ProjectStatus, item.ProjectStatuses_ProjectSuperStatus);
    }
  }
}